const integerFormatter = new Intl.NumberFormat('en-US', {
  maximumFractionDigits: 0,
});

const compactIntegerFormatter = new Intl.NumberFormat('en-US', {
  notation: 'compact',
  maximumFractionDigits: 0,
});

export function toRoundedInteger(value = 0) {
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? Math.round(numericValue) : 0;
}

export function formatCompactInteger(value = 0, compactFrom = 10000) {
  const integerValue = toRoundedInteger(value);
  const formatter = Math.abs(integerValue) >= compactFrom
    ? compactIntegerFormatter
    : integerFormatter;

  return formatter.format(integerValue).toLowerCase();
}

export function formatPoints(value = 0, compactFrom = 10000) {
  return `${formatCompactInteger(value, compactFrom)} pt`;
}
